import React from 'react'
import PropTypes from 'prop-types'
import { MaxWidthGridV2 } from 'Layout'
import MlsDisclaimer from 'Components/MlsDisclaimer'


const ListingDisclaimer = ({ listing }) => {
  const isVancouverListing = listing?.source === 'REBGV'
  const isKWFeed = listing?.source === 'ITSO'
  const isPillar9 = listing?.source === 'PILLAR9'
  return (
    <MaxWidthGridV2>
      {
        isVancouverListing || isKWFeed || isPillar9 ?
          <MlsDisclaimer isKWFeed={isKWFeed} isPillar9={isPillar9} />
          : ''
      }
    </MaxWidthGridV2>
  )
}


ListingDisclaimer.propTypes = {
  listing: PropTypes.shape({
    source: PropTypes.string,
  }),
}

export default ListingDisclaimer
